export const responseToSentryContext = async (response: Response) => {
  const responseBody = await response
    .clone()
    .json()
    .catch(() => response.text())
    .catch(() => 'Unable to read response body');

  return {
    status: response.status,
    statusText: response.statusText,
    url: response.url,
    headers: Object.fromEntries(response.headers.entries()),
    body: responseBody,
  };
};
